import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {GENERAL_DIMENSIONS_STATE_NAME, GeneralDimensionsState} from './generalDimensions';
import {Serializers} from '../../interfaces/serializer';
import {GeneralDimension} from '../../interfaces/dimensions';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';

export const selectGeneralDimensionsState: MemoizedSelector<object, GeneralDimensionsState> = createFeatureSelector(GENERAL_DIMENSIONS_STATE_NAME);

export const selectGeneralDimensions: MemoizedSelector<object, Serializers<GeneralDimension>> = createSelector(
  selectGeneralDimensionsState,
  (state: GeneralDimensionsState): Serializers<GeneralDimension> => state.serialized
);

export const selectGeneralDimensionComponentObjects: MemoizedSelector<object, DimensionComponentObjects> = createSelector(
  selectGeneralDimensionsState,
  (state: GeneralDimensionsState): DimensionComponentObjects => state.componentObjects
);

export const selectGeneralDimensionsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectGeneralDimensionsState,
  (state: GeneralDimensionsState): boolean => state.loaded
);
